import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { throwErrorMessage } from "../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./loader.constants";
import { isValidKeyValue } from "./loader.validation";

@Injectable({
  providedIn: "root"
})
export class KwikUILoaderService {
  // Create a Subject to track loader visibility changes
  showLoaderSubject = new BehaviorSubject<boolean>(false);

  // Expose an observable to subscribe to loader visibility changes
  showLoader: Observable<any> = this.showLoaderSubject.asObservable();

  loading = false;

  fullscreen: boolean = DEFAULT_VALUES.fullscreen;

  id: string = DEFAULT_VALUES.id;

  loaderText: string = DEFAULT_VALUES.loaderText;

  constructor() {
    for (const inputs of Object.entries(VALIDATE_KEY_VALUES)) {
      const key: string = inputs[0];
      const validate: any = inputs[1];

      if (validate) {
        this.validateInputProperty(key, this[key]);
      }
    }
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-loader",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  show(options?: { loaderText?: string; fullscreen?: boolean }): boolean {
    this.showLoaderSubject.next(true);
    this.loading = true;

    if (options) {
      this.loaderText = options.loaderText || this.loaderText;
      this.fullscreen = options.fullscreen ?? this.fullscreen;
    }

    return this.loading;
  }

  hide(): boolean {
    this.loading = false;
    this.showLoaderSubject.next(false);

    return this.loading;
  }
}
